var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot-status"},[_c('div',{staticClass:"fas fa-circle",class:_vm.testResultIcon,attrs:{"title":_vm.tooltip ? _vm.form.name : '',"data-toggle":"tooltip","data-placement":"top"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }